import type { EmployerDayTimeBucket } from '../utils/employerTaskDayGrouping';

export type GreetingTimeBucket = Exclude<EmployerDayTimeBucket, 'noTime'>;

export const getCurrentHourInTimezone = (timezone: string): number =>
  Number(
    new Intl.DateTimeFormat('en-GB', {
      timeZone: timezone,
      hour: 'numeric',
      hour12: false,
    })
      .formatToParts(new Date())
      .find((part) => part.type === 'hour')?.value ?? '12',
  );

/** Aligns with task list time-of-day buckets (00:00–04:59 … 18:00–23:59). */
export const resolveGreetingTimeBucket = (hour: number): GreetingTimeBucket => {
  if (hour >= 0 && hour <= 4) {
    return 'lateNight';
  }
  if (hour >= 5 && hour <= 11) {
    return 'morning';
  }
  if (hour >= 12 && hour <= 17) {
    return 'afternoon';
  }
  return 'evening';
};

const GREETING_KEY_BY_BUCKET: Record<
  GreetingTimeBucket,
  { helper: string; employer: string }
> = {
  lateNight: {
    helper: 'helperHome.greetLateNight',
    employer: 'employerDashboard.greetLateNight',
  },
  morning: {
    helper: 'helperHome.greetMorning',
    employer: 'employerDashboard.greetMorning',
  },
  afternoon: {
    helper: 'helperHome.greetAfternoon',
    employer: 'employerDashboard.greetAfternoon',
  },
  evening: {
    helper: 'helperHome.greetEvening',
    employer: 'employerDashboard.greetEvening',
  },
};

export const resolveGreetingI18nKey = (
  bucket: GreetingTimeBucket,
  scope: 'helper' | 'employer',
): string => GREETING_KEY_BY_BUCKET[bucket][scope];
